import { useState, useEffect } from 'react'

const mediaQueryToMatch = '(max-width: 767px)'

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window === 'undefined'
      ? false
      : window.matchMedia(mediaQueryToMatch).matches
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(mediaQueryToMatch)
    const handleResize = () => setIsMobile(mediaQuery.matches)
    mediaQuery.addEventListener('change', handleResize)
    return () => mediaQuery.removeEventListener('change', handleResize)
  }, [mediaQueryToMatch])

  return isMobile
}

export default useIsMobile
